// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M0Hc","colMin":"styles_colMin__H8caz"};